// extracted by mini-css-extract-plugin
module.exports = {"card":"_10MhcmXsuZS1BUSnkedZah"};